import type { ArticleStatus } from '@rankhelm/shared';

interface StatusBadgeProps {
  status: ArticleStatus;
  className?: string;
}

const STATUS_CONFIG: Record<string, { label: string; bg: string; text: string; pulse?: boolean }> = {
  queued: { label: 'Queued', bg: 'bg-slate-600', text: 'text-white' },
  generating: { label: 'Generating...', bg: 'bg-yellow-600', text: 'text-white', pulse: true },
  draft: { label: 'Draft', bg: 'bg-blue-600', text: 'text-white' },
  in_review: { label: 'In Review', bg: 'bg-purple-600', text: 'text-white' },
  revision_requested: { label: 'Revision Requested', bg: 'bg-orange-600', text: 'text-white' },
  approved: { label: 'Approved', bg: 'bg-green-600', text: 'text-white' },
  scheduled: { label: 'Scheduled', bg: 'bg-cyan-600', text: 'text-white' },
  publishing: { label: 'Publishing...', bg: 'bg-yellow-600', text: 'text-white', pulse: true },
  published: { label: 'Published', bg: 'bg-emerald-600', text: 'text-white' },
  publish_failed: { label: 'Publish Failed', bg: 'bg-red-600', text: 'text-white' },
};

export function StatusBadge({ status, className = '' }: StatusBadgeProps) {
  const config = STATUS_CONFIG[status] || { label: status, bg: 'bg-slate-600', text: 'text-white' };
  return (
    <span
      className={`inline-flex items-center px-3 py-1 rounded text-xs font-semibold whitespace-nowrap min-w-[130px] justify-center ${config.bg} ${config.text} ${config.pulse ? 'animate-pulse' : ''} ${className}`}
    >
      {config.label}
    </span>
  );
}
